import moment from 'moment';
import jwtDecode from "jwt-decode";

export function hasAccessTokenExpired(token?: string) {
  const decodedToken: any = token
    ? jwtDecode(token)
    : null

  return token
    ? moment.unix(decodedToken.exp).isSameOrBefore()
    : false;
}
